import Dashboard from "../layout/Dashboard";
import SignIn from "../layout/SignIn";

const indexRoutes = [
  { path: "/sign-in", component: SignIn },
  { path: "/", component: Dashboard }
];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.js